export const DESCRIPTION_ALIGN_OPTIONS = [
  { value: 'auto', icon: 'bi-arrow-left-right', labelKey: 'planDetail.days.descriptionAlign.auto' },
  { value: 'ltr', icon: 'bi-text-left', labelKey: 'planDetail.days.descriptionAlign.ltr' },
  { value: 'rtl', icon: 'bi-text-right', labelKey: 'planDetail.days.descriptionAlign.rtl' },
  { value: 'center', icon: 'bi-text-center', labelKey: 'planDetail.days.descriptionAlign.center' },
];

export const normalizeDescriptionAlign = (value) => {
  if (DESCRIPTION_ALIGN_OPTIONS.some((option) => option.value === value)) {
    return value;
  }
  return 'auto';
};

export const getDescriptionAlignStyle = (alignValue) => {
  const align = normalizeDescriptionAlign(alignValue);

  switch (align) {
    case 'ltr':
      return { dir: 'ltr', textAlign: 'left' };
    case 'rtl':
      return { dir: 'rtl', textAlign: 'right' };
    case 'center':
      return { textAlign: 'center' };
    case 'auto':
    default:
      return {};
  }
};
